import { MessageCircle } from "lucide-react";
import { useLang, WHATSAPP_NUMBER } from "@/lib/i18n";

export default function WhatsAppCTA({ message, variant = "primary", className = "", "data-testid": testId }) {
  const { t } = useLang();
  const text = message || t.app.whatsapp.hello_said;
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
  const styles =
    variant === "primary"
      ? "bg-emerald-600 hover:bg-emerald-700 text-white"
      : "bg-white border border-emerald-600 text-emerald-700 hover:bg-emerald-50";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId || "whatsapp-cta"}
      className={`inline-flex items-center gap-2 h-12 px-5 rounded-xl font-semibold transition-colors ${styles} ${className}`}
    >
      <MessageCircle size={18} />
      {t.app.whatsapp.cta_said}
    </a>
  );
}
